
export enum Path {
  Home = '/register',
  Home2 = '/home',
  About = '/about',
  //ContactUs = '/contact',

  Login = '/login',
  UserDashboard = '/user/dashboard',
  Facilitator = '/',

  AdminDashboard = '/admin/dashboard',






}
